import React from 'react'
import styles from './ImageIconsBox.module.sass'
import { MenuItemType } from '@next-nx/utils/types'
import { WContainer, WImage } from '@next-nx/shared-ui/atoms'
import IconTextDescriptionItem from '../../molecules/IconTextDescriptionItem/IconTextDescriptionItem'

interface Props {
  className?: string
  item?: MenuItemType
}

const ImageIconsBox = (props: Props) => {
  const { className = '', item = undefined } = props

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
      {!!item?.name && (
        <div className={styles.layout}>
          <div className={styles.title}>{item.name}</div>
        </div>
      )}
      <div className={styles.layout}>
        <div className={styles.imageBox}>
          <WImage
            maxWidth={476}
            maxHeight={432}
            className={styles.image}
            src={item?.image}
            objectFit={'cover'}
            layout={'intrinsic'}
          />
        </div>
        <div className={styles.content}>
          {item?.children?.edges?.map((x, index) => (
            <div className={styles.item}>
              <IconTextDescriptionItem item={x?.node} className={styles.item} />
            </div>
          ))}
        </div>
      </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default ImageIconsBox
